import PayMonthlyDeduction from '@/api/hr/pay-monthly-deduction'
import Employee from '@/api/hr/employee'
import DeductionItem from '@/api/hr/pay-item-deduction'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  cycle_year: moment().format('YYYY'),
  cycle_month: moment().format('MM'),
  employees: [],
  deductions: [],
  itemDeductions: [],
  leaveRecords: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_DEDUCTIONS(state, deductions) {
    state.deductions = deductions
  },
  RECEIVE_ITEM_DEDUCTIONS(state, data) {
    state.itemDeductions = data
  },
  RECEIVE_LEAVE_RECORDS(state, data) {
    state.leaveRecords = data
  },
  SET_CYCLE_YEAR(state, data) {
    state.cycle_year = data
  },
  SET_CYCLE_MONTH(state, data) {
    state.cycle_month = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        cycle_month: context.state.cycle_month,
        cycle_year: context.state.cycle_year,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayMonthlyDeduction.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayMonthlyDeduction.store(data)
  },

  generate(context, data) {
    return PayMonthlyDeduction.importLeave(data)
  },

  update(context, { id, ...data }) {
    return PayMonthlyDeduction.update(id, data)
  },

  destroy(context, id) {
    return PayMonthlyDeduction.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.record_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        hris_employee_profiles: 'employee_id,employee_name_en'
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchDeductions(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        pay_item_deduction: 'deduction_id,deduction_item'
      },
      ...attributes
    }

    return DeductionItem.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params
    }).then(response => {
      context.commit('RECEIVE_DEDUCTIONS', response.data)
      return Promise.resolve(response)
    })
  },

  async dataBeforeCreate(context) {
    if (!context.state.itemDeductions.length > 0) {
      let response = await PayMonthlyDeduction.getItemDeduction()
      context.commit('RECEIVE_ITEM_DEDUCTIONS', response.data)
    }
  },
  fetchLeaveRecord(context, data = {}) {
    return PayMonthlyDeduction.getLeaveRecord({ leave_type_id: data.item_type_id }).then(response => {
      context.commit('RECEIVE_LEAVE_RECORDS', response.data)
      return Promise.resolve(response)
    })
  }
}
